module.exports = __webpack_public_path__ + "static/img/tzsl.d89913b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/tzsl.svg
// module id = k1CH
// module chunks = 2